<template name="userPermission">
	<div class="content">
		<!--上个页面来源 从公司人员列表来 -->
		<div v-if="show==0">
      <div style="display: flex;justify-content: center;">
        <el-input style="width: 60%;margin-right: 10px"
                  placeholder="输入用户名搜索"
                  v-model="searchName" @clear="clear"
                  clearable>
        </el-input>
        <el-button icon="el-icon-search" circle @click="search"></el-button>
      </div>
			<div style="margin-top: 10px;">
				<el-table :data="permissionList" style="width: 100%;text-align: center; height: 100%; " border
					ref="refTable" :header-cell-style="{ background: '#F2F2F2', color: '#333' }">
					<el-table-column prop="userId" label="用户id" width="80" show-overflow-tooltip align="center" />
					<el-table-column prop="nickname" label="用户姓名" width="580" show-overflow-tooltip align="center" />
					<el-table-column label="身份" min-width="110" show-overflow-tooltip align="center">
						<template v-slot="scope">
							<div v-if="scope.row.role_type==0" class="info-content">开发者</div>
							<div v-if="scope.row.role_type==1" class="info-content">普通用户</div>
						</template>
					</el-table-column>
					<el-table-column  label="页面分配" min-width="110" show-overflow-tooltip align="center">
						<template v-slot="scope">
							<el-button @click="mainPageManage(scope.row)" type="primary" size="small">分配页面</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<!-- 分配权限的页面，之后要把projectId和permission去掉 -->
		<pageDistribute v-if="show==1" :companyId="companyId" :selectUserId="distributeId" @return="returnBack()">
		</pageDistribute>
	</div>
</template>

<script>
	import PageDistribute from './PageDistribute'
  import API from "@/../config/api.js";
	export default {
		name: "userPermission",
		props: {
			companyId: Number,
		},
		components: {
      PageDistribute
		},
		data() {
			return {
				pageNum: 1,
				pages: 1,
				show: false,
				searchName: '', //模糊查询用户名
				appendChild: {},
				pageType: 0,
				permissionList: [],
				projectId: '',
				userId: '', //登录用户
				customStyle: {
					color: '#3399ff',
				},
				distributeId: 0, //记录是为谁分配权限
			}
		},
		mounted() {
			this.userId = window.localStorage.getItem('userid');
			console.log('人员管理userId的值=', this.userId);
			console.log(this.companyId)
			console.log('开始进行公司员工处理ing')
			this.permissionList = []
			this.pageNum = 1
			this.getAllUserOfCompany(); //在页面上显示该公司的所有开发者

		},
		methods: {
			// 获取当前公司所有的员工
			getAllUserOfCompany() {
				let header = {
					"Content-Type": "application/x-www-form-urlencoded"
				}
				// 参数要有当前公司的companyId
				let data = {
					companyId: this.companyId,
					//role_type: 1, //身份是普通用户
					nickname: this.searchName, //后面根据端口进行修改，传递查询参数
				}
				console.log(data)
				// 获取非当前用户的其他所有用户
				this.$axiosRequest({
					url: API.getAllDeveloperOfCompany, //后面根据后端接口进行修改
					method: 'POST',
					data: data,
					header: header,
					success: res => {
						console.log("当前第", this.pages, "页")
						console.log(this.permissionList)
						this.permissionList = res.data["userList"]; //之后要改
					}
				});
			},
			//进入页面分配页面
			mainPageManage(item) {
				this.distributeId = item.userId; //记录是为谁分配权限
				this.show = 1;
			},
			returnBack() {
				this.show = 0;
				this.permissionList.length = 0; //重新刷新一下
				this.pageNum = 1
				this.getAllUserOfCompany(); //在页面上显示该公司的所有开发者
			},
			clear() {
				this.permissionList.length = 0; //重新刷新一下    //先把列表清空
				this.pageNum = 1;
				this.getAllUserOfCompany();
			},
			search() {
				this.permissionList.length = 0; //重新刷新一下
				this.getAllUserOfCompany();
			}
		}

	}
</script>

<style>
	.info-title {
		font-size: 18px;
		font-weight: bold;
		color: #004768;
		font-family: '仿宋';
	}

	.info-content {
		font-size: 18px;
		font-family: '仿宋';
	}

	.button-group-card {
		margin: 10px 15px 10px 15px;
		padding: 12px;
	}

	.button-group-title {
		font-size: 18px;
		font-weight: bold;
	}

	.info-card {
		margin: 10px 15px 10px 15px;
		padding: 12px;
		background-color: #ffffff;
	}



	.info-content {
		margin: 10px 0px 10px 10px;
		height: auto;
	}

	.title-style {
		font-size: 18px;
		font-weight: bold;
	}

	.title2-style {
		font-size: 15px;
		line-height: 40px;
	}

	.btn {
		margin-left: 80px;

	}

	.button-group-card2 {
		padding: 12px;
		bottom: 0;
		right: 0;
		left: 0;
		position: fixed
	}
</style>
